import Service from './Service';
import {SERVER_URL} from "../utils/Constants";

export default class RoomService extends Service{
    constructor() {
        super();
        this.baseURL = 'room';
    }
}